import { render } from "./StoreBusinessVerticals.vue?vue&type=template&id=3a836a9e"
import script from "./StoreBusinessVerticals.vue?vue&type=script&lang=js"
export * from "./StoreBusinessVerticals.vue?vue&type=script&lang=js"
/* custom blocks */
import block0 from "./StoreBusinessVerticals.i18n.json?vue&type=custom&index=0&blockType=i18n&issuerPath=%2Ftmp%2Fbuild_d50d1876%2Fpackages%2Fbo%2Fsrc%2Fcomponents%2Fstore%2Fdetails%2FStoreBusinessVerticals.vue&external"
if (typeof block0 === 'function') block0(script)


import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__